module.exports = __webpack_public_path__ + "img/ico_biaoqiannvwusheng.b3f1d87b.png";